import styled from 'styled-components';
import PropTypes from 'prop-types';
import { color, typography } from 'styles/settings';
import { normalize, withModifiers } from 'utils';

const BaseH = styled.span`
  color: ${(props) => props.color ?? color.neutral.gray};
  ${typography.font.semiBold};
  ${withModifiers('upperCase')`
    text-transform: uppercase;
  `};
`;

export const H1 = styled(BaseH)`
  font-size: ${typography.size.xl};
`;

H1.propTypes = {
  upperCase: PropTypes.bool,
};

export const H2 = styled(BaseH)`
  font-size: ${typography.size.lg};
  line-height: ${typography.size.xl};
`;

H2.propTypes = {
  upperCase: PropTypes.bool,
};

export const H3 = styled(BaseH)`
  font-size: ${typography.size.rg};
`;

H3.propTypes = {
  upperCase: PropTypes.bool,
};

export const H4 = styled(BaseH)`
  font-size: ${typography.size.sm};
  line-height: ${normalize('18px')};
`;

H4.propTypes = {
  upperCase: PropTypes.bool,
};

export const H5 = styled(BaseH)`
  font-size: ${typography.size.xxs};
`;

H5.propTypes = {
  upperCase: PropTypes.bool,
};

export const Label = styled.span`
  color: ${color.neutral.black};
  ${typography.font.medium};
  font-size: ${typography.size.rg};
  opacity: ${({ opacity = 1 }) => opacity};
  ${withModifiers('secondary')`
    font-size: ${typography.size.xs};
  `}
  ${withModifiers('upperCase')`
    text-transform: uppercase;
  `};
  ${withModifiers('$invalid')`
    color: ${color.ui.danger};
  `}
`;

Label.propTypes = {
  secondary: PropTypes.bool,
  uppercase: PropTypes.bool,
};

export const P = styled.span`
  color: ${color.neutral.white};
  line-height: ${typography.size.ml};
  ${typography.font.regular};
  font-size: ${typography.size.rg};
  opacity: ${({ opacity = 1 }) => opacity};
  ${withModifiers('secondary')`
    line-height: ${typography.size.md};
    font-size: ${typography.size.sm};
  `}
  ${withModifiers('tertiary')`
    line-height: ${typography.size.rg};
    font-size: ${typography.size.xs};
  `}
  ${withModifiers('upperCase')`
    text-transform: uppercase;
  `};
  ${withModifiers('centered')`
    text-align: center;
  `}
`;

P.propTypes = {
  secondary: PropTypes.bool,
  tertiary: PropTypes.bool,
  uppercase: PropTypes.bool,
  centered: PropTypes.bool,
};
